import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dashboard__section"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Members", -1)
const _hoisted_3 = { class: "high-em" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" (pending invite) ")
const _hoisted_5 = { class: "table__cell--clickable" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "high-em" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" (you) ")
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_10 = { class: "high-em" }
const _hoisted_11 = { class: "table__cell--clickable" }
const _hoisted_12 = { class: "dashboard__section" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, "Invite a New Member", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h4", null, "Permissions", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Invite ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_table_row = _resolveComponent("table-row")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_input = _resolveComponent("base-input")!
  const _component_permissions_switches = _resolveComponent("permissions-switches")!
  const _component_loading_button = _resolveComponent("loading-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.membersResponse?.data.length !== 0 || _ctx.invites.length !== 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invites, (invite, index) => {
                return (_openBlock(), _createBlock(_component_table_row, { key: index }, {
                  text: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(invite.inviteeEmail), 1),
                    _hoisted_4
                  ]),
                  buttons: _withCtx(() => [
                    _createElementVNode("td", _hoisted_5, [
                      _createElementVNode("button", {
                        class: "table__cell-button align-right",
                        onClick: ($event: any) => (_ctx.revokeInvite(invite.id))
                      }, [
                        _createVNode(_component_fa_icon, {
                          class: "danger text--large",
                          icon: ['far', 'times']
                        })
                      ], 8, _hoisted_6)
                    ])
                  ]),
                  _: 2
                }, 1024))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.membersResponse?.data, (member, index) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                  (member.id?.toString() === _ctx.customerID)
                    ? (_openBlock(), _createBlock(_component_table_row, {
                        key: 0,
                        clickable: false
                      }, {
                        text: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(member.fullName), 1),
                          _hoisted_8
                        ]),
                        buttons: _withCtx(() => [
                          _hoisted_9
                        ]),
                        _: 2
                      }, 1024))
                    : (_openBlock(), _createBlock(_component_table_row, {
                        key: 1,
                        clickable: true,
                        onClick: ($event: any) => (_ctx.$router.push(`/dashboard/${_ctx.$route.params.subdomain}/members/${member.id}`))
                      }, {
                        text: _withCtx(() => [
                          _createElementVNode("span", _hoisted_10, _toDisplayString(member.fullName), 1),
                          _createTextVNode(" (" + _toDisplayString(member.email) + ") ", 1)
                        ]),
                        buttons: _withCtx(() => [
                          _createElementVNode("td", _hoisted_11, [
                            _createVNode(_component_router_link, {
                              class: "table__cell-button",
                              to: `/dashboard/${_ctx.$route.params.subdomain}/members/${member.id}`
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_fa_icon, {
                                  class: "high-em text--large",
                                  icon: ['far', 'eye']
                                })
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                ], 64))
              }), 128))
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("form", {
        onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
      }, [
        _createVNode(_component_base_input, {
          class: "full-width",
          placeholder: "Email",
          error: _ctx.emailError,
          modelValue: _ctx.createInviteData.email,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.createInviteData.email) = $event)),
          modelModifiers: { trim: true }
        }, null, 8, ["error", "modelValue"]),
        _hoisted_14,
        _createVNode(_component_permissions_switches, {
          modelValue: _ctx.createInviteData.permissions,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.createInviteData.permissions) = $event))
        }, null, 8, ["modelValue"]),
        _createElementVNode("div", null, [
          _createVNode(_component_loading_button, {
            "button-type": "button--inverted",
            class: "input-button-group__button",
            loading: _ctx.formLoading
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }, 8, ["loading"])
        ])
      ], 32)
    ])
  ]))
}